const PLACEMENT_OPTIONS = [
	'top',
	'top-start',
	'top-end',
	'right',
	'right-start',
	'right-end',
	'bottom',
	'bottom-start',
	'bottom-end',
	'left',
	'left-start',
	'left-end'
];

export {
	PLACEMENT_OPTIONS
};
